// File: src/App.js
// License: All Rights Reserved
// Copyright (c) 2024 Byron Korir

import React, { useContext, useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AccommodationContext } from '../context/AccommodationContext';
import LoadingComponent from '../components/LoadingComponent';

const Accommodations = () => {
  const navigate = useNavigate();
  const {loading, searchTerm, setSearchTerm,accommodations,category, setCategory, searchResults, categoryResults} = useContext(AccommodationContext)

 
  const handleRowClick = (id) => {
    navigate(`/accommodations/${id}`);
    
  };
  const loadingText = 'Loading ....'


const [filteredItems, setFilteredItems] = useState([]);
const [search, setSearch] = useState(''); // Initialize search state
const [accommodationsToDisplay, setAccommodationsToDisplay] = useState([])

useEffect(() => {
  if (category !== 'all' ) {
    setAccommodationsToDisplay(categoryResults);
  } else if (searchTerm !== '' && search !== '') {
    setAccommodationsToDisplay(searchResults);
  }else{
    setAccommodationsToDisplay(accommodations)
  }
  
  // setAccommodationsToDisplay(accommodations)
}, [category, searchTerm, accommodations, categoryResults, searchResults, search]);


  
  const handleSearch = (e) => {
    const term = e.target.value.toLowerCase();
    setSearch(term);
  
    if (term.length > 0) {
      const filtered = new Set(); // Use a Set to store unique search results
  
      accommodations.forEach(item => {
        const accommodationName = item.accommodation?.toLowerCase();
        const locationName = item.location?.toLowerCase();
  
        if (accommodationName?.includes(term)) {
          filtered.add(item.accommodation);
        }
        if (locationName?.includes(term)) {
          filtered.add(item.location);
        }
      });
  
      // Convert Set to an array and sort alphabetically
      const sortedFilteredItems = [...filtered].sort((a, b) => a.localeCompare(b));
      setFilteredItems(sortedFilteredItems);
    } else {
      setFilteredItems([]);
      setAccommodationsToDisplay(accommodations)
    }
  };
  function handleSubmit(e){
    e.preventDefault()
    setSearchTerm(search)
    setCategory('all')
  }

  const handleItemClick = (item) => {
    setSearch(item);
    setFilteredItems([]);
  };


  return (
    <div className="container-fluid pb-4" style={{backgroundColor:'rgb(8, 50, 32,1)',minHeight:'100%'}}>
      <h2 className="text-center pt-4 mb-4" style={{ fontFamily: 'inknut antiqua', fontWeight: 'bold', color: 'wheat' }}>
        Accommodations
      </h2>
      {/* Search Input Field */}
      <div className="container d-flex flex-wrap justify-content-center mb-3" style={{ maxWidth: '100%', margin: 'auto' }}>
        <form className="input-group position-relative" style={{ maxWidth: '20rem' }} onSubmit={handleSubmit}>
            <input
              type="search"
              className="form-control text-center border border-success"
              placeholder="Search 🔍"
              value={search}
              onChange={handleSearch}
              style={{ fontSize: '1rem' }}
            />
            <button className="btn btn-success" type="submit">🔍</button>
            {filteredItems.length > 0 && (
              <ul className="list-group position-absolute w-100" style={{ top: '100%', zIndex: 1 }}>
                {filteredItems.map((item, index) => (
                  <li
                    key={index}
                    className="list-group-item list-group-item-action"
                    onClick={() => handleItemClick(item)}
                  >
                    {item}
                  </li>
                ))}
              </ul>
            )}
        </form>
        <div className="form-group ms-3 ">
            <select 
            className="form-control" 
            id="dropdownSelect"
            value={category}
            onChange={(e) => setCategory(e.target.value)}>
               <option value="all">All</option>
               <option value="Hotel">Hotels</option>
               <option value="Camp">Camps</option>
            </select>
         </div>
         <div className="d-flex justify-content-end">
            <Link className='btn btn-info ms-5' to={'/accommodations/add'}>
              Add 
            </Link>
          </div>
      </div>
      

      {loading ? (
        <LoadingComponent loadingText={loadingText}/>
      ) : accommodations && accommodations.length === 0 ? (
        <div className="alert alert-info" role="alert">
          No accommodations found.
        </div>
      ) : (
        <div className="table-responsive bg-white bg-opacity-75 rounded">
          <table className="table table-striped rounded table-hover text-center" >
            <thead>
              <tr className='text-success fs-5' >
                <th></th>
                <th>Name</th>
                <th>Location</th>
                <th>Category</th>
                <th>email</th>
                <th>phone</th>
              
              </tr>
            </thead>
            <tbody>
            {Array.isArray(accommodationsToDisplay) && accommodationsToDisplay.length > 0 && accommodationsToDisplay.map((accomodation, index) => (
               <tr key={accomodation.id} onClick={() => handleRowClick(accomodation.id)}>
                  <td style={{ fontSize: '0.85em' }}>{index + 1}</td>
                  <td style={{ fontSize: '0.85em' }}>{accomodation.accommodation}</td>
                  <td style={{ fontSize: '0.85em' }}>{accomodation.location}</td>
                  <td style={{ fontSize: '0.85em' }}>{accomodation.category}</td>
                  <td style={{ fontSize: '0.85em' }}><a href={`mailto:${accomodation.email}`}>{accomodation.email}</a></td>
                  <td style={{ fontSize: '0.85em' }}>{accomodation.phone}</td>
               </tr>
               ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default Accommodations;
